import useRightEdgeLauncherPosition from 'hooks/chat/useRightEdgeLauncherPosition';
import { useRef } from 'react';
import { Rnd } from 'react-rnd';
import { IconButton, styled } from 'shell/components';

import {
    LauncherBottomPaddingPx,
    LauncherHeightPx,
    LauncherInitialTopPx,
    LauncherRightOffsetPx,
    LauncherTopPaddingPx,
    LauncherWidthPx,
} from './constants';

const HugoLauncherControl = ({ onOpen, onVerticalPositionChange, verticalPosition }) => {
    const shouldSuppressClickRef = useRef(false);
    const { position, onDragStop } = useRightEdgeLauncherPosition({
        bottomPadding: LauncherBottomPaddingPx,
        height: LauncherHeightPx,
        initialY: LauncherInitialTopPx,
        onVerticalPositionChange,
        rightOffset: LauncherRightOffsetPx,
        topPadding: LauncherTopPaddingPx,
        verticalPosition,
        width: LauncherWidthPx,
    });

    return (
        <HugoLauncher
            bounds={'window'}
            dragAxis={'y'}
            dragHandleClassName={'hugo-launcher-drag-handle'}
            enableResizing={false}
            position={position}
            size={{ width: LauncherWidthPx, height: LauncherHeightPx }}
            onDrag={() => {
                shouldSuppressClickRef.current = true;
            }}
            onDragStop={onDragStop}
        >
            <HugoLauncherButton
                aria-label={'Open Hugo instructor assistant'}
                className={'hugo-launcher-drag-handle'}
                kind={'messageSparkle'}
                size={'large'}
                variant={'square'}
                onClick={(event) => {
                    if (shouldSuppressClickRef.current) {
                        event.preventDefault();
                        event.stopPropagation();
                        shouldSuppressClickRef.current = false;
                        return;
                    }

                    onOpen();
                }}
            />
        </HugoLauncher>
    );
};

const HugoLauncher = styled(Rnd)(({ theme }) => {
    return {
        position: 'fixed',
        zIndex: theme.zIndex.drawer + 2,
    };
});

const HugoLauncherButton = styled(IconButton)(({ theme }) => {
    return {
        width: '100%',
        height: '100%',
        borderRadius: '10px 0 0 10px',
        background: theme.palette.ensightful.neutral[900],
        boxShadow: theme.palette.ensightful.shadows[2],
        color: theme.palette.ensightful.shades[0],
        touchAction: 'none',
        transition: theme.transitions.default,

        '&:active': {
            cursor: 'grabbing',
        },
        '&:hover': {
            background: theme.palette.ensightful.neutral[800],
            color: theme.palette.ensightful.shades[0],
        },
        '&:focus-visible': {
            outline: `${theme.palette.ensightful.secondary[400]} solid 3px`,
            outlineOffset: '4px',
        },
        '& svg': {
            fontSize: '24px',
        },
    };
});

export default HugoLauncherControl;
